import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Fires a GA4/gtag page_view event on every route change.
 * Renders nothing — place it inside <BrowserRouter>.
 */
export function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);

  return null;
}
